import React, { useEffect, useRef, useState } from 'react';
import ServicePage from '../views/ServicePage';
import { useServiceContext } from './Context/ServiceContext';

const DashboardComponent = () => {
    const { AddServiceCategory, FetchServiceCategory, AddAditionalService, FetchAdditionalService, serviceCategory, additionalService, UpdateServiceCategory, editServiceCategory, DeleteServiceCategory, editOpen, editType, currentEditData, setEditOpen } = useServiceContext();
    const [loading, setLoading] = useState(true);
    const didFetch = useRef(false);
    const getData = async () => {
        try {
            await FetchServiceCategory();
            await FetchAdditionalService();
        
            setLoading(false); // Set loading to false once data is fetched


        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    useEffect(() => {
        if (!didFetch.current) {
            getData();
            didFetch.current = true; // Mark the API call as done
        }
    });

    return (
  
        <div>
         {/*   {loading && <div>Loading...</div>}*/}
            {!loading  && <ServicePage />}
        </div>

    );
};

export default DashboardComponent;